import { FC } from 'react'
import useChartStore from '../../store/chart/useChartStore'
import { useQuery } from '@tanstack/react-query'
import { getWeightHistogram } from '@/api/chart/chart.service'
import { Card } from '@nextui-org/react'
import { SingleDomainHistogram } from './plot/SingleDomainHistogram'
import { Spinner } from '@chakra-ui/react'
import { EmptyChartState } from './EmptyChartState'
import '../../styles/responsive.css'

export type HistComponentProps = {
  date: Date
  schoolColors: { [id: string]: string }
}

export const HistComponent: FC<HistComponentProps> = ({ date, schoolColors }) => {
  // 로컬 시간대 기준으로 날짜를 YYYY-MM-DD 형태로 변환 (API 스펙에 맞춤)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const dateString = `${year}-${month}-${day}`

  const { selectedSchools, selectedTanks } = useChartStore()
  const labels = Object.fromEntries(selectedTanks.map((t) => [t.schoolId, t.tankName]))

  const histQueryResult = useQuery({
    queryKey: ['histogram', selectedSchools, date],
    queryFn: async () => {
      if (selectedSchools.length === 0) return null
      return await getWeightHistogram(selectedSchools, dateString)
    },
    staleTime: 500,
  })
  return (
    <div className="flex flex-col">
      <div className="mx-1 mb-1 flex flex-row justify-between">
        <p className="font-bold text-[1.25rem]">Weight Histogram</p>
      </div>
      {histQueryResult.isLoading ? (
        <Card
          shadow="none"
          className="h-[300px] max-h-[50vh] sm:h-[400px] md:h-[450px] lg:h-[500px] min-w-[100%] border-[1px] border-tdpldarkgrey border-opacity-60
          flex items-center justify-center"
        >
          <Spinner color="#B98CA4" emptyColor="gray.200" size="lg" />
        </Card>
      ) : histQueryResult.isError ? (
        <EmptyChartState
          title="Weight Histogram"
          message="Failed to load histogram data. Please try again."
        />
      ) : !histQueryResult.data || histQueryResult.data === null ? (
        <EmptyChartState
          title="Weight Histogram"
          message="No data available for the selected date"
        />
      ) : (
        <Card
          shadow="none"
          className="min-w-[100%] border-[1px] border-tdpldarkgrey border-opacity-60"
        >
          <div className="p-0 h-[300px] sm:h-[400px] md:h-[450px] lg:h-[500px] chart-container-mobile">
            <SingleDomainHistogram
              schoolColors={schoolColors}
              histQueryResult={histQueryResult.data}
              labels={labels}
            />
          </div>
        </Card>
      )}
    </div>
  )
}
